import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { detectInitialLanguage, getTranslation, LOCAL_STORAGE_KEY } from "../i18n";
import { PUBLIC_LANGUAGE_CHANGE_EVENT } from "../lib/cmsI18n";

const LangCtx = createContext(null);

/**
 * Public site dil tercihi; admin panel `AdminSection` ile sınırlı değil ama Provider yalnızca Layout’ta kullanılıyor.
 * @typedef {{ language: 'tr' | 'en'; setLanguage: (l: 'tr'|'en')=>void; t: (key: string, vars?: Record<string, string | number>) => string }} LanguageValue
 */

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => detectInitialLanguage());

  useEffect(() => {
    try {
      window.localStorage.setItem(LOCAL_STORAGE_KEY, language);
    } catch (_) {
      /* ignore */
    }
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("lang", language === "tr" ? "tr" : "en");
      window.dispatchEvent(new CustomEvent(PUBLIC_LANGUAGE_CHANGE_EVENT, { detail: { language } }));
    }
  }, [language]);

  /** @type {(l: 'tr'|'en')=>void} */
  const setLanguage = useCallback((lng) => {
    if (lng === "tr" || lng === "en") setLanguageState(lng);
  }, []);

  const t = useCallback((key, vars) => getTranslation(language, key, vars), [language]);

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);

  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

/** @returns {LanguageValue} */
export function useLanguage() {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLanguage yalnızca LanguageProvider içinde kullanılmalıdır");
  return ctx;
}
